import { render } from "./PuntoPickMpio.vue?vue&type=template&id=0e803a82"
import script from "./PuntoPickMpio.vue?vue&type=script&lang=ts"
export * from "./PuntoPickMpio.vue?vue&type=script&lang=ts"
script.render = render

export default script